// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.depm {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.depm .avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 1rem;
  color: #fff;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-entity/v-entity.component.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AAER","sourcesContent":[".depm\n    display: flex\n    align-items: center\n    gap: 0.5rem\n    .avatar\n        display: inline-flex\n        align-items: center\n        justify-content: center\n        width: 2rem\n        height: 2rem\n        flex-shrink: 0\n        border-radius: 50%\n        font-size: 1rem\n        color: #fff\n        user-select: none\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
